module.exports = __webpack_public_path__ + "img/logo-win.a03d4657.png";